module.exports = __webpack_public_path__ + "static/media/spice_screenshot.42de5e95.webp";